import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Palette, Eye, MessageSquare, Zap, Users, CheckCircle } from 'lucide-react';

const FltrLiteProInfo = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-white py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold mb-8">
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>
        
        <div className="bg-white rounded-2xl shadow-2xl p-8 border-4 border-blue-600">
          <h1 className="text-5xl font-black text-gray-900 mb-6 text-center">FltrLite Pro</h1>
          <p className="text-2xl font-bold text-blue-600 mb-8 text-center">
            Unlock the full potential of your FltrLnk Business Profile
          </p>

          {/* Overview */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Overview</h2>
            <p className="text-lg text-gray-700 mb-6">
              FltrLite Pro is the ultimate upgrade packed with premium features and advanced tools built to expand your network, strengthen connections, and reach new users across the platform who can become loyal customers for your business.
            </p>
          </div>

          {/* Premium Features */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Premium Features Included</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-600">
                <Shield className="w-10 h-10 text-blue-600 mb-3" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">User Profile Verification & Verification Badge</h3>
                <p className="text-gray-700">Get your profile verified with an official badge to build trust and credibility.</p>
              </div>
              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-600">
                <Palette className="w-10 h-10 text-blue-600 mb-3" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Full Profile Customization</h3>
                <p className="text-gray-700">Customize every aspect of your profile to reflect your unique brand identity.</p>
              </div>
              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-600">
                <Eye className="w-10 h-10 text-blue-600 mb-3" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Full Profile Visibility</h3>
                <p className="text-gray-700">Maximize your reach with enhanced visibility in search results and discovery features.</p>
              </div>
              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-600">
                <MessageSquare className="w-10 h-10 text-blue-600 mb-3" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Unlimited Business Chats</h3>
                <p className="text-gray-700">Connect with unlimited users and never miss a business opportunity.</p>
              </div>
              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-600">
                <Zap className="w-10 h-10 text-blue-600 mb-3" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">100 Monthly Boosts for 7 User Boosts</h3>
                <p className="text-gray-700">Get 100 boosts every month across 7 different boost types to increase your visibility.</p>
              </div>
              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-600">
                <Users className="w-10 h-10 text-blue-600 mb-3" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">Early Founder Invite Rewards</h3>
                <p className="text-gray-700">Earn rewards by inviting other businesses to join FltrLnk.</p>
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Terms & Conditions</h2>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                <span>All features are subject to FltrLnk Terms of Service and may be modified with reasonable notice.</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                <span>Monthly boosts reset on the first day of each month.</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                <span>Subscription is non-transferable.</span>
              </li>
            </ul>
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <Link 
              to="/"
              className="inline-block bg-gradient-to-r from-blue-600 to-blue-800 text-white px-12 py-4 rounded-xl font-bold text-xl hover:shadow-2xl transition-all transform hover:scale-105"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FltrLiteProInfo;
